import { render, staticRenderFns } from "./DataObject.vue?vue&type=template&id=663a7fea"
import script from "./DataObject.vue?vue&type=script&lang=js"
export * from "./DataObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports